export class Usuario {
  t1_id: number | null;
  t1_privilegios: number | null;
  t1_accesos: any;
  t1_sub: string;
  t1_email: string;
  t1_name: string;
  t1_estado: number | null;

  t1_fecha_registro?: Date; // Campo opcional para mostrar la fecha de registro
  t1_ultimo_acceso?: Date; // Campo opcional para mostrar el último acceso

  constructor() {
    this.t1_id = null;
    this.t1_privilegios = null;
    this.t1_accesos = '';
    this.t1_sub = '';
    this.t1_email = '';
    this.t1_name = '';
    this.t1_estado = null;
  }
}
